import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import React from 'react';
import { Controller } from 'react-hook-form';
import RichEditor from './RichEditor';

/** MyMine Version1.5 追加
 * 入力チェック用RichEditor Component
 */
const ValidatableRichEditor = ({
  controllerName,
  control,
  rules,
  formState,
  name,
  editorValue,
  setEditorValue,
  isReloadValue,
  setIsReloadValue,
  editorProps,
}) => {

  return (
    <FormControl
      error={formState.errors[controllerName] ? true : false}
      sx={{
        width: "100%",
        '.rdw-editor-main': { border: formState.errors[controllerName] ? 'solid 1px rgba(211, 47, 47)' : 'solid 1px rgba(224, 224, 224, 1)' }
      }} >
      <Controller
        control={control}
        name={name}
        defaultValue={editorValue}
        render={({ field: { ref, ...field } }) =>
          <RichEditor
            {...field}
            editorValue={editorValue}
            onChange={((e) => {
              field.onChange(e);
              setEditorValue && setEditorValue(e);
            })}
            isReloadValue={isReloadValue}
            setIsReloadValue={setIsReloadValue}
            {...editorProps}
          />
        }
        rules={rules}
      />
      <FormHelperText>{formState.errors[controllerName]?.message}</FormHelperText>
    </FormControl>
  );
};
export default ValidatableRichEditor;
